import path from 'path';
import { tryExecute } from '@fluss/core';
import { URL_DELIMITER } from './constants.js';

/** Checks if text is URL. */
const isUrl = (text) =>
	tryExecute(
		// If text is not URL then error will be thrown.
		// https://developer.mozilla.org/en-US/docs/Web/API/URL
		() => new URL(text),
	)
		.map(() => true)
		.extract(() => false);

/**
 * Converts a URL to filesystem path.
 * It gets path part of the URL and match it
 * to the filesystem path.
 */
const urlToPath = (url) => (prefix) =>
	path.join(
		prefix,
		new URL(url).pathname.slice(1).split(URL_DELIMITER).join(path.sep),
	);

/** Prepends leading slash if url doesn't have it.  */
const withLeadingSlash = (url) =>
	url.startsWith(URL_DELIMITER) ? url : URL_DELIMITER + url;

/** Delete last slash if url have it.  */
const trimLastSlash = (url) =>
	url.endsWith(URL_DELIMITER) ? url.slice(0, -1) : url;

/** Predicate that detects remote URLs.  */
const isRemoteLink = (value) => /^https?/.test(value);

/** Checks if an url is absolute. */
const isAbsoluteURL = (url) => url.startsWith(URL_DELIMITER);

/** Checks if an url is from Public Internet. */
const isPublicInternetURL = (url) =>
	url.startsWith('http') || url.startsWith('https');

export { isAbsoluteURL, isPublicInternetURL, isRemoteLink, isUrl, trimLastSlash, urlToPath, withLeadingSlash };
